import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import PatchPesticideRequirement from '.';
interface IPostPesticideRequirementProps {
  onSuccess?: (data: any) => void;
  guid?: string;
}

const usePatchPesticideRequirement = ({
  onSuccess,
  guid,
}: IPostPesticideRequirementProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IPesticideRequirementPayload) => {
      return PatchPesticideRequirement(payload, guid);
    },
    onSuccess: data => {
      onSuccess && onSuccess(data);
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export {usePatchPesticideRequirement};
